import { Dispatch } from 'react';
import { AudioAction, AudioActionTypes } from '../type';
import { getWords } from '../../../textbook/api/fetchWords';
import { wordsResponse } from '../../../textbook/types';
import { getUserWords } from '../../../textbook/api/fetchUserWords';

export const fetchAudioWords = (page: number, group: number) => {
  return async (dispatch: Dispatch<AudioAction>) => {
    try {
      dispatch({
        type: AudioActionTypes.FETCH_AUDIO_WORDS,
      });
      const words = await getWords(page, group);
      const set: Set<wordsResponse> = new Set();
      while (set.size < 20) {
        set.add(words[Math.floor(Math.random() * 20)]);
      }
      const res = Array.from(set);
      dispatch({ type: AudioActionTypes.FETCH_AUDIO_WORDS_SUCCESS, payload: res });
    } catch (error) {}
  };
};

export const fetchUserAudioWords = (userId: string, group: number, page: number) => {
  return async (dispatch: Dispatch<AudioAction>) => {
    try {
      dispatch({
        type: AudioActionTypes.FETCH_AUDIO_WORDS,
      });
      const words = await getUserWords(userId, `{"$and":[{"group": ${group}, "page": ${page}}]}`);
      const set: Set<wordsResponse> = new Set();
      while (set.size < 20) {
        set.add(words[Math.floor(Math.random() * 20)]);
      }
      const res = Array.from(set);
      dispatch({ type: AudioActionTypes.FETCH_AUDIO_WORDS_SUCCESS, payload: res });
    } catch (error) {}
  };
};

export const createPageLoop = (currPage: number, maxPages = 30) => {
  const arr = Array(maxPages).fill(null);

  const res = arr.map((_, i) => {
    let page = currPage - i;
    page = i <= currPage ? page : maxPages + page;

    return page;
  });

  return res;
};

export const fetchFilteredAudioWords = (userId: string, group: number, page: number) => {
  return async (dispatch: Dispatch<AudioAction>) => {
    try {
      dispatch({
        type: AudioActionTypes.REMOVE_WORDS,
      });
      const pageNumber = +page;
      const pageLoop = createPageLoop(pageNumber);
      let perPage = 20;
      let count = 0;
      const getWords = async (pageNum: number, perPageNum: number) => {
        const filter = {
          $and: [
            { group: +group, page: pageNum },
            { $or: [{ 'userWord.optional.learned': false }, { userWord: null }] },
          ],
        };
        const stringifyFilter = JSON.stringify(filter);
        const words = await getUserWords(
          userId,
          `{"$and":[{"group": ${group}, "page": ${page}}]}`,
          `${perPage}`
        );
        const set: Set<wordsResponse> = new Set(words);
        while (set.size < words.length) {
          set.add(words[Math.floor(Math.random() * words.length)]);
        }
        const res = Array.from(set);
        dispatch({
          type: AudioActionTypes.UPDATE_WORDS,
          payload: res,
        });
        count += 1;
        perPage -= words.length;
        if (count >= pageLoop.length || perPage <= 0) return;
        await getWords(pageLoop[count], perPage);
      };
      await getWords(pageLoop[count], perPage);
    } catch (error) {}
  };
};

export function updateGroupAudio(id: number): AudioAction {
  return { type: AudioActionTypes.UPDATE_GROUP, payload: id };
}

export function removeWordsAudio(): AudioAction {
  return { type: AudioActionTypes.REMOVE_WORDS };
}

export function getAudioAnswers(answers: string[]): AudioAction {
  return { type: AudioActionTypes.UPDATE_ANSWER, payload: answers };
}

export function audioQuestion(question: number): AudioAction {
  return { type: AudioActionTypes.UPDATE_QUESTION, payload: question };
}
